import { useCallback, useEffect, useState } from "react";
import { api } from "@/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { StatsStrip } from "@/components/StatsStrip";
import { Packages } from "@/components/Packages";
import { Accommodation } from "@/components/Accommodation";
import { ReviewsSection } from "@/components/ReviewsSection";
import { Payment } from "@/components/Payment";
import { BookingForm } from "@/components/BookingForm";
import { About } from "@/components/About";
import { BlogSection } from "@/components/BlogSection";
import { Footer } from "@/components/Footer";

export default function Home() {
    const [packages, setPackages] = useState([]);
    const [settings, setSettings] = useState(null);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        api.get("/packages").then(({ data }) => {
            setPackages(data);
            if (data.length) setSelected(data[0].id);
        }).catch(() => {});
        api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
    }, []);

    const onBook = useCallback((pkg) => {
        setSelected(pkg.id);
        document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
    }, []);

    const whatsapp = settings?.whatsapp || "919199335409";

    return (
        <div data-testid="home-page">
            <Navbar settings={settings} />
            <Hero whatsapp={whatsapp} />
            <Marquee />
            <StatsStrip />
            <Packages packages={packages} onBook={onBook} />
            <Accommodation whatsapp={whatsapp} />
            <ReviewsSection />
            <Payment settings={settings} pkg={packages.find((p) => p.id === selected)} />
            <BookingForm
                packages={packages}
                settings={settings}
                selected={selected}
                onSelect={setSelected}
            />
            <BlogSection />
            <About />
            <Footer settings={settings} />
        </div>
    );
}
